import React, { useState } from 'react';
import { Maximize2 } from 'lucide-react';
import { Modal } from './Modal';

interface SistemKayitlariProps {
  value: string | null | undefined;
}

export const SistemKayitlari: React.FC<SistemKayitlariProps> = ({ value }) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <div>
        <div className="flex items-center justify-between mb-1">
          <label className="text-xs font-bold text-gray-400">Sistem Kayıtları</label>
          {value && (
            <button
              type="button"
              onClick={() => setOpen(true)}
              className="text-gray-400 hover:text-gray-600 transition"
              title="Tam ekran görüntüle"
            >
              <Maximize2 size={12} />
            </button>
          )}
        </div>
        <div className="bg-gray-50 border border-gray-200 p-2 rounded text-[10px] font-mono text-gray-500 h-24 overflow-y-auto whitespace-pre-wrap">
          {value || 'Henüz sistem kaydı yok.'}
        </div>
      </div>

      <Modal isOpen={open} onClose={() => setOpen(false)} title="Sistem Kayıtları" size="lg">
        <div className="bg-gray-50 border border-gray-200 p-3 rounded text-xs font-mono text-gray-600 max-h-[60vh] overflow-y-auto whitespace-pre-wrap">
          {value || 'Henüz sistem kaydı yok.'}
        </div>
      </Modal>
    </>
  );
};
